module.exports = __webpack_public_path__ + "img/idriss_d.ea043ce3.png";